import useSeasonalChartSeries from '@/components/Chart/hooks/useSeasonalChartSeries';
import type { ChartDataRange } from '@/components/Chart/types/chartData';
import BasicChartBlock from '@/pages/Markets/MarketsComponents/Chart/BasicChartBlock';
import type { TemplateChartSeries } from '@/pages/Markets/MarketsComponents/types';

type SeasonalChartBlockType = {
  layout?: { fullWidth?: boolean; height?: number };
  templateChartSeries?: TemplateChartSeries[];
  chartDataRange: ChartDataRange;
};
const SeasonalChartBlock = ({
  layout,
  templateChartSeries,
  chartDataRange
}: SeasonalChartBlockType) => {
  const { loading, error, chartSeries } = useSeasonalChartSeries(
    templateChartSeries,
    chartDataRange
  );

  return (
    <BasicChartBlock
      chartSeries={chartSeries}
      chartType='seasonal'
      error={error}
      layout={layout}
      loading={loading}
    />
  );
};

export default SeasonalChartBlock;
